import memoize from "fast-memoize";
import fetch from "./fetch-trade-api";

const models = memoize(
  async ({ yearId, makeId }) => {
    const resp = await fetch(`/v1/report/models/year/${yearId}/make/${makeId}`);
    const models = await resp.json();
    return new Map(Object.entries(models));
  },
  {
    serializer: ({ yearId, makeId }) => `${yearId}-${makeId}`
  }
);

export const label = async ({ yearId, makeId, modelId }) => {
  const map = await models({ yearId, makeId });
  return map.get(modelId);
};

export default models;
